import { render, staticRenderFns } from "./newEnergy.vue?vue&type=template&id=823bfb2e&scoped=true"
import script from "./newEnergy.vue?vue&type=script&lang=js"
export * from "./newEnergy.vue?vue&type=script&lang=js"
import style0 from "./newEnergy.vue?vue&type=style&index=0&id=823bfb2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823bfb2e",
  null
  
)

export default component.exports